import React from "react";
import { Icon, Text, Flex, Box } from "@chakra-ui/react";
import {
  textSecondary,
  buttonBlue,
  buttonBlueText,
  buttonBlueDark,
  buttonGreen,
  buttonGreenText,
  buttonGreenDark,
  buttonRed,
  buttonRedText,
  buttonRedDark,
  buttonYellow,
  buttonYellowText,
  buttonYellowDark,
  white,
  backgroundLight,
  newBorder,
  buttonOrange,
  buttonOrangeText,
  buttonOrangeDark,
  buttonGreenVividDark,
  buttonAltGrey,
  buttonAltPrimary,
  buttonAltGreen,
  buttonAltYellow,
  buttonAltSuccess,
  buttonAltRed,
  buttonAltBlue,
  text,
  textPrimary,
  color6,
  color3,
  color5,
  color2,
  color1,
  color4,
  color8,
} from "../../utils/colors";
import { useTranslation } from "react-i18next";
import {
  FaRegCircleDot,
  FaRegCircle,
  FaCircleHalfStroke,
  FaCircleXmark,
  FaClock,
  FaCircleCheck,
} from "react-icons/fa6";
import { shade } from "polished";

const StatusBadgeNew = ({
  status,
  options,
  onChange,
  noText,
  iconFontSize,
  ...rest
}) => {
  const { t } = useTranslation();
  const translate = (key) => t(key);

  if (options === "paid") {
    options = [
      {
        value: "unpaid",
        label: translate("status.unpaid"),
        icon: FaCircleXmark,
        bg: buttonOrange,
        bgDark: buttonOrangeDark,
        color: buttonOrangeText,
        borderColor: buttonOrange,
        bgHover: "#dda3a3",
      },
      {
        value: "paid",
        label: translate("status.paid"),
        icon: FaCircleCheck,
        bg: buttonGreen,
        bgDark: buttonGreenDark,
        color: buttonGreenText,
        borderColor: buttonGreen,
        bgHover: "#9ebfc2",
      },
    ];
  } else if (options === "plans") {
    options = [
      {
        value: "draft",
        label: translate("status.cancelledPlan"),
        icon: FaCircleXmark,
        bg: buttonAltGrey,
        bgDark: textSecondary,
        color: textSecondary,
        borderColor: newBorder,
        bgHover: "#ddd",
      },
      {
        value: "active",
        label: translate("status.cancelledPlan"),
        icon: FaCircleXmark,
        bg: buttonAltGreen,
        bgDark: buttonGreenDark,
        color: buttonGreenText,
        borderColor: buttonGreen,
        bgHover: "#9ebfc2",
      },
      {
        value: "canceled",
        label: translate("status.cancelledPlan"),
        icon: FaCircleXmark,
        bg: buttonAltRed,
        bgDark: buttonRedDark,
        color: buttonRedText,
        borderColor: buttonRed,
        bgHover: "#dda3a3",
      },
    ];
  } else if (options === "treatment") {
    options = [
      {
        value: "draft",
        label: translate("status.draft"),
        icon: FaRegCircle,
        bg: buttonAltGrey,
        bgDark: textSecondary,
        color: textSecondary,
        borderColor: newBorder,
        bgHover: "#ddd",
      },
      {
        value: "approved",
        label: translate("status.treatmentPlanApproved"),
        icon: FaCircleCheck,
        bg: color3,
        bgDark: buttonGreenDark,
        color: white,
        borderColor: buttonGreen,
        bgHover: "#9ebfc2",
      },

      {
        value: "consulting",
        label: translate("status.treatmentPlanConsulting"),
        icon: FaClock,
        bg: color1,
        bgDark: buttonBlueDark,
        color: white,
        borderColor: newBorder,
        bgHover: "#ddd",
      },
      {
        value: "planning",
        label: translate("status.treatmentPlanPlanning"),
        icon: FaClock,
        bg: color2,
        bgDark: buttonYellowDark,
        color: white,
        borderColor: buttonYellow,
        bgHover: "#9ebfc2",
      },
      {
        value: "completed",
        label: translate("status.treatmentPlanCompleted"),
        icon: FaCircleCheck,
        bg: color5,
        bgDark: buttonGreenDark,
        color: textPrimary,
        borderColor: buttonGreen,
        bgHover: "#9ebfc2",
      },
      {
        value: "cancelled",
        label: translate("status.treatmentPlanCancelled"),
        icon: FaCircleXmark,
        bg: color6,
        bgDark: buttonRedDark,
        color: white,
        borderColor: buttonRed,
        bgHover: "#dda3a3",
      },
      {
        value: "ongoing",
        label: translate("status.ongoing"),
        icon: FaCircleHalfStroke,
        bg: color4,
        bgDark: buttonYellowDark,
        color: white,
        borderColor: buttonAltYellow,
        bgHover: "#9ebfc2",
      },
    ];
  } else if (options === "treatmentPublic") {
    options = [
      {
        value: "draft",
        label: translate("status.draft"),
        icon: FaRegCircle,
        bg: buttonAltGrey,
        bgDark: textSecondary,
        color: textSecondary,
        borderColor: newBorder,
        bgHover: "#ddd",
      },
      {
        value: "approved",
        label: translate("status.treatmentPlanApproved"),
        icon: FaCircleCheck,
        bg: buttonAltGreen,
        bgDark: buttonGreenDark,
        color: buttonGreenText,
        borderColor: buttonGreen,
        bgHover: "#9ebfc2",
      },

      {
        value: "consulting",
        label: translate("status.waitingForApprovalPublic"),
        icon: FaClock,
        bg: buttonAltPrimary,
        bgDark: buttonBlueDark,
        color: textPrimary,
        borderColor: newBorder,
        bgHover: shade(0.8, buttonAltPrimary),
      },
      {
        value: "planning",
        label: translate("status.waitingForApprovalPublic"),
        icon: FaClock,
        bg: buttonAltPrimary,
        bgDark: buttonYellowDark,
        color: textPrimary,
        borderColor: buttonYellow,
        bgHover: "#9ebfc2",
      },
      {
        value: "completed",
        label: translate("status.treatmentPlanCompleted"),
        icon: FaCircleCheck,
        bg: buttonAltSuccess,
        bgDark: buttonGreenDark,
        color: buttonGreenText,
        borderColor: buttonGreen,
        bgHover: "#9ebfc2",
      },
      {
        value: "cancelled",
        label: translate("status.treatmentPlanCancelled"),
        icon: FaCircleXmark,
        bg: buttonAltRed,
        bgDark: buttonRedDark,
        color: buttonRedText,
        borderColor: buttonRed,
        bgHover: "#dda3a3",
      },
      {
        value: "ongoing",
        label: translate("status.ongoing"),
        icon: FaCircleHalfStroke,
        bg: buttonAltYellow,
        bgDark: buttonYellowDark,
        color: textPrimary,
        borderColor: buttonAltYellow,
        bgHover: "#9ebfc2",
      },
    ];
  } else if (options === "senderIdentity") {
    options = [
      {
        value: "unverified",
        label: translate("status.senderIdentityUnverified"),
        icon: FaRegCircle,
        bg: buttonAltGrey,
        bgDark: textSecondary,
        color: text,
        borderColor: buttonAltGrey,
        bgHover: "#ddd",
      },

      {
        value: "verified",
        label: translate("status.senderIdentityVerified"),
        icon: FaCircleCheck,
        bg: buttonAltGreen,
        bgDark: buttonGreenDark,
        color: buttonGreenText,
        borderColor: buttonAltGreen,
        bgHover: "#9ebfc2",
      },
      {
        value: "verified",
        label: translate("status.senderIdentityPending"),
        icon: FaCircleHalfStroke,
        bg: buttonAltYellow,
        bgDark: buttonYellowDark,
        color: buttonYellowText,
        borderColor: buttonAltYellow,
        bgHover: "#9ebfc2",
      },
    ];
  } else if (options === "user") {
    options = [
      {
        value: "new",
        label: translate("status.patientNew"),
        icon: FaRegCircleDot,
        bg: color8,
        bgDark: buttonBlueDark,
        color: textPrimary,
        borderColor: buttonBlue,
        bgHover: "#b6cce1",
      },
      {
        value: "inactive",
        label: translate("status.patientInactive"),
        icon: FaRegCircle,
        bg: buttonAltGrey,
        bgDark: textSecondary,
        color: text,
        borderColor: buttonAltGrey,
        bgHover: "#ddd",
      },

      {
        value: "active",
        label: translate("status.patientActive"),
        icon: FaCircleCheck,
        bg: buttonAltGreen,
        bgDark: buttonGreenDark,
        color: buttonGreenText,
        borderColor: buttonAltGreen,
        bgHover: "#9ebfc2",
      },
      {
        value: "consulting",
        label: translate("status.patientConsulting"),
        icon: FaClock,
        bg: buttonAltPrimary,
        bgDark: buttonBlueDark,
        color: textPrimary,
        borderColor: newBorder,
        bgHover: "#ddd",
      },
      {
        value: "planningTreatment",
        label: translate("status.patientPlanningTreatment"),
        icon: FaClock,
        bg: buttonAltPrimary,
        bgDark: buttonYellowDark,
        color: textPrimary,
        borderColor: buttonYellow,
        bgHover: "#9ebfc2",
      },
      {
        value: "approvedTreatment",
        label: translate("status.patientApprovedTreatment"),
        icon: FaCircleCheck,
        bg: buttonAltGreen,
        bgDark: buttonGreenDark,
        color: buttonGreenText,
        borderColor: buttonAltGreen,
        bgHover: "#9ebfc2",
      },
      {
        value: "ongoingTreatment",
        label: translate("status.patientOngoingTreatment"),
        icon: FaCircleHalfStroke,
        bg: buttonAltYellow,
        bgDark: buttonYellowDark,
        color: buttonYellowText,
        borderColor: buttonAltYellow,
        bgHover: "#9ebfc2",
      },
      {
        value: "cancelledTreatment",
        label: translate("status.patientCancelledTreatment"),
        icon: FaCircleXmark,
        bg: buttonAltRed,
        bgDark: buttonRedDark,
        color: buttonRedText,
        borderColor: buttonRed,
        bgHover: "#dda3a3",
      },
      {
        value: "completedTreatment",
        label: translate("status.patientCompletedTreatment"),
        icon: FaCircleCheck,
        bg: buttonAltSuccess,
        bgDark: buttonGreenVividDark,
        color: textPrimary,
        borderColor: buttonAltSuccess,
        bgHover: "#dda3a3",
      },
    ];
  } else if (options === "patient") {
    options = [
      {
        value: "new",
        label: translate("patientStatus.new"),
        icon: FaRegCircleDot,
        bg: color8,
        bgDark: buttonBlueDark,
        color: textPrimary,
        borderColor: buttonBlue,
        bgHover: "#b6cce1",
      },
      {
        value: "draft",
        label: translate("patientStatus.draft"),
        icon: FaRegCircle,
        bg: buttonAltGrey,
        bgDark: textSecondary,
        color: textSecondary,
        borderColor: newBorder,
        bgHover: "#ddd",
      },
      {
        value: "approvedTreatment",
        label: translate("patientStatus.approvedTreatment"),
        icon: FaCircleCheck,
        bg: color3,
        bgDark: buttonGreenDark,
        color: white,
        borderColor: buttonGreen,
        bgHover: "#9ebfc2",
      },

      {
        value: "planningTreatment",
        label: translate("patientStatus.planningTreatment"),
        icon: FaClock,
        bg: color2,
        bgDark: buttonYellowDark,
        color: white,
        borderColor: buttonYellow,
        bgHover: "#9ebfc2",
      },
      {
        value: "completedTreatment",
        label: translate("patientStatus.completedTreatment"),
        icon: FaCircleCheck,
        bg: color5,
        bgDark: buttonGreenDark,
        color: textPrimary,
        borderColor: buttonGreen,
        bgHover: "#9ebfc2",
      },
      {
        value: "cancelledTreatment",
        label: translate("patientStatus.cancelledTreatment"),
        icon: FaCircleXmark,
        bg: color6,
        bgDark: buttonRedDark,
        color: white,
        borderColor: buttonRed,
        bgHover: "#dda3a3",
      },
      {
        value: "ongoingTreatment",
        label: translate("patientStatus.ongoingTreatment"),
        icon: FaCircleHalfStroke,
        bg: color4,
        bgDark: buttonYellowDark,
        color: white,
        borderColor: buttonAltYellow,
        bgHover: "#9ebfc2",
      },
    ];
  } else if (options === "appointment") {
    options = [
      {
        value: null,
        label: translate("status.unpaid"),
        icon: FaCircleXmark,
        bg: buttonRed,
        bgDark: buttonRedDark,
        color: buttonRedText,
        borderColor: buttonRed,
        bgHover: "#dda3a3",
      },
      {
        value: "no_appointment",
        label: translate("status.noAppointment"),
        icon: FaCircleXmark,
        bg: buttonRed,
        bgDark: buttonRedDark,
        color: buttonRedText,
        borderColor: buttonRed,
        bgHover: "#dda3a3",
      },
    ];
  } else {
    options = [
      {
        value: "new",
        label: translate("status.new"),
        icon: FaClock,
        bg: buttonYellow,
        bgDark: buttonYellowDark,
        color: buttonYellowText,
        borderColor: buttonYellow,
        bgHover: "#b6cce1",
      },
      {
        value: "cancelled",
        label: translate("status.cancelled"),
        icon: FaCircleXmark,
        bg: buttonRed,
        bgDark: buttonRedDark,
        color: buttonRedText,
        borderColor: buttonRed,
        bgHover: "#dda3a3",
      },
      {
        value: "completed",
        label: translate("status.completed"),
        icon: FaCircleCheck,
        bg: buttonGreen,
        bgDark: buttonGreenDark,
        color: buttonGreenText,
        borderColor: buttonGreen,
        bgHover: "#9ebfc2",
      },
      {
        value: "planning",
        label: translate("status.planning"),
        icon: FaClock,
        bg: buttonYellow,
        bgDark: buttonYellowDark,
        color: buttonYellowText,
        borderColor: buttonYellow,
        bgHover: "#b6cce1",
      },
      {
        value: "approved",
        label: translate("status.approved"),
        icon: FaCircleCheck,
        bg: buttonGreen,
        bgDark: buttonGreenDark,
        color: buttonGreenText,
        borderColor: buttonGreen,
        bgHover: "#9ebfc2",
      },
      {
        value: "consulting",
        label: "Consulting",
        icon: FaCircleHalfStroke,
        bg: buttonBlue,
        bgDark: buttonBlueDark,
        color: buttonBlueText,
        borderColor: newBorder,
        bgHover: "#ddd",
      },
      {
        value: "draft",
        label: translate("status.draft"),
        icon: FaRegCircle,
        bg: backgroundLight,
        bgDark: textSecondary,
        color: textSecondary,
        borderColor: newBorder,
        bgHover: "#ddd",
      },
      {
        value: "ongoing",
        label: translate("status.ongoing"),
        icon: FaCircleCheck,
        bg: buttonGreen,
        bgDark: buttonGreenDark,
        color: buttonGreenText,
        borderColor: buttonGreen,
        bgHover: "#9ebfc2",
      },
    ];
  }

  const currentStatusOption = options.find((option) => option.value === status);

  return (
    <Box>
      {status && (
        <Flex
          {...rest}
          align="center"
          justify="center"
          bg={currentStatusOption ? currentStatusOption.bg : white}
          borderRadius="10rem"
          onClick={() => onChange && onChange(status)}
        >
          <Icon
            iconFontSize={iconFontSize ? iconFontSize : "1rem"}
            color={
              currentStatusOption ? currentStatusOption.color : textSecondary
            }
            as={currentStatusOption ? currentStatusOption.icon : FaRegCircle}
          />
          {!noText && (
            <Text
              ml={2}
              color={
                currentStatusOption ? currentStatusOption.color : textSecondary
              }
              fontWeight="500"
            >
              {currentStatusOption && currentStatusOption.label}
            </Text>
          )}
        </Flex>
      )}
    </Box>
  );
};

export default StatusBadgeNew;
